import { CancelToken } from 'axios';
import { analytics } from '@saucelabs/sl-util-axios';

import { REQUEST_CANCEL_MESSAGE } from './../../constants';

const cancelRefs = {};

/**
 * @param {Object} params
 * @param {string} params.query
 */
export function getTestNames(params) {
  return analytics.get('/_test-names', { params });
}

/**
 * @param {Object} params
 * @param {string} params.testName
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTestMetrics(params) {
  return analytics.get('/insights/test-metrics', { params });
}

/**
 * @param {Object} params
 * @param {string} params.query - Test name
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTests(params, { cancelTokenID } = {}) {
  if (cancelTokenID && cancelRefs[cancelTokenID]) {
    cancelRefs[cancelTokenID](REQUEST_CANCEL_MESSAGE);
  }
  const cancelToken = new CancelToken((cancel) => {
    cancelRefs[cancelTokenID] = cancel;
  });
  return analytics.get('/tests', { params, cancelToken });
}

export function getTestHistory(params) {
  return analytics.get('/history/tests', { params });
}
